import { render, staticRenderFns } from "./PelleStrike.vue?vue&type=template&id=3d6b11a3"
import script from "./PelleStrike.vue?vue&type=script&lang=js"
export * from "./PelleStrike.vue?vue&type=script&lang=js"
import style0 from "./PelleStrike.vue?vue&type=style&index=0&id=3d6b11a3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports